import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sun, Moon, Github, User, LogOut, FileText, ChevronDown, LogIn, ExternalLink } from 'lucide-react';
import Logo from './Logo';
import { useAuth } from '../contexts/AuthContext';

const Header = ({ theme, toggleTheme }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
    navigate('/');
  };

  return (
    <header className="header">
      <Link to="/" className="logo">
        <Logo size={32} />
        <span>Scrawl</span>
      </Link>
      
      <nav className="nav-links">
        <Link to="/" className="nav-link">+ New</Link>
        <Link to="/url-opener" className="nav-link icon-link" title="Open Paste by URL">
          <ExternalLink size={20} />
          <span>URLs</span>
        </Link>
        <a 
          href="https://github.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="nav-link icon-link"
          title="GitHub"
        >
          <Github size={20} />
        </a>
        <button 
          className="theme-toggle" 
          onClick={toggleTheme}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        </button>

        {/* Auth */}
        {isAuthenticated ? (
          <div className="user-menu" ref={dropdownRef}>
            <button 
              className="user-button"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <div className="user-avatar">
                {user.username[0].toUpperCase()}
              </div>
              <span className="user-name">@{user.username}</span>
              <ChevronDown size={16} className={`chevron ${showDropdown ? 'rotated' : ''}`} />
            </button>

            {showDropdown && (
              <div className="user-dropdown">
                <div className="dropdown-header">
                  <div className="dropdown-avatar">
                    {user.username[0].toUpperCase()}
                  </div>
                  <div>
                    <div className="dropdown-username">@{user.username}</div>
                    <div className="dropdown-email">{user.email}</div>
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                <Link 
                  to="/dashboard" 
                  className="dropdown-item"
                  onClick={() => setShowDropdown(false)}
                >
                  <FileText size={16} />
                  My Pastes
                </Link>
                <Link 
                  to="/dashboard" 
                  className="dropdown-item"
                  onClick={() => setShowDropdown(false)}
                >
                  <User size={16} />
                  Settings
                </Link>
                <div className="dropdown-divider"></div>
                <button 
                  className="dropdown-item danger"
                  onClick={handleLogout}
                >
                  <LogOut size={16} />
                  Sign Out
                </button>
              </div>
            )}
          </div>
        ) : (
          <Link to="/login" className="nav-link auth-link">
            <LogIn size={18} />
            <span>Sign In</span>
          </Link>
        )}
      </nav>
    </header>
  );
};

export default Header;